import { useEffect, useState } from 'react';
import { getInvalidCount } from '~/lib/validation';
import useBasket from './use-basket';
import { DEBOUNCE_TIME } from '~/lib/constants';

const useProgress = (id?: string) => {
  const { changes, count, initialised } = useBasket();
  const [scrollPercentage, setScrollPercentage] = useState<number>(0);
  useEffect(() => {
    const t = setTimeout(() => {
      const result = getInvalidCount(id);
      setScrollPercentage(result.percentageComplete);
    }, DEBOUNCE_TIME);
    return () => clearTimeout(t);
  }, [changes, count, initialised, id]);
  return scrollPercentage;
};
export default useProgress;
